import React, { PureComponent, Fragment } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Button, Checkbox, Row, Col, Card, message, Modal, Tooltip } from 'antd';
import { Link } from 'dva/router';
import { connect } from 'dva';
import EditRegionSelector from './EditRegionSelector';
import PolicySelector from './PolicySelector';

//   const formItemLayout = {
//     labelCol: { span: 4 },
//     wrapperCol: { span: 8 },
//   };
//   const formTailLayout = {
//     labelCol: { span: 4 },
//     wrapperCol: { span: 8, offset: 4 },
//   };
@connect(({ cloudAccount, loading }) => ({
  updating: cloudAccount.updating,
}))
class Azure extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      checkNick: false,
      regions: [],
      visible: false,
      visibleSecretKey: false,
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
      visibleSecretKey: false,
    });
  };

  showModalSecretKey = () => {
    this.setState({
      visible: false,
      visibleSecretKey: true,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
      visibleSecretKey: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
      visibleSecretKey: false,
    });
  };

  check = () => {
    this.props.form.validateFields(err => {
      if (!err) {
        console.info('success');
      }
    });
  };

  handleChange = e => {
    this.setState(
      {
        checkNick: e.target.checked,
      },
      () => {
        this.props.form.validateFields(['nickname'], { force: true });
      }
    );
  };

  selectedregion(regions) {
    this.setState({
      regions,
    });
  }

  selectedpolicy(policy) {
    this.setState({
      policy,
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      values.regions = this.state.regions;
      values.cloudAccount = this.props.customerData[0].id;
      values.provider = this.props.customerData[0].provider;

      if (!err) {
        this.props.updateData(values);

        // message.success('CloudAccount updated successfully');

        const { dispatch } = this.props;
      } else {
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { customerData } = this.props;
    return (
      <div>
        <div style={{ marginTop: 13 }}>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col span={10}>
                <Form.Item label="Azure Account Name">
                  {getFieldDecorator('AzureAccountName', {
                    initialValue:
                      customerData && customerData[0].accountName
                        ? customerData[0].accountName
                        : '',

                    rules: [
                      {
                        message: 'Please enter your Azure Account Name',
                      },
                    ],
                  })(<Input placeholder="Azure Account Name" />)}
                </Form.Item>
              </Col>
              <Col span={10} offset={2}>
                <Form.Item label="Select Regions">
                  {getFieldDecorator('SelectRegions', {
                    rules: [
                      {
                        required: this.state.checkNick,
                        message: 'Please Select your Regions',
                      },
                    ],
                  })(
                    <EditRegionSelector
                      provider={customerData && customerData[0].provider}
                      region={customerData && customerData[0].regions}
                      selectregion={this.selectedregion.bind(this)}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                {/* <Form.Item label="Subscription ID">
                  {getFieldDecorator('SubscriptionID', {
                    initialValue:
                      customerData && customerData[0].subscriptionId
                        ? customerData[0].subscriptionId
                        : '',

                    rules: [
                      {
                        message: 'Please enter your subscriptionId',
                      },
                    ],
                  })(<Input  placeholder="SubscriptionId" disabled />)}
                </Form.Item> */}
              </Col>
              <Col span={10} offset={2}>
                {/* <Form.Item label="App/ClientID">
                  {getFieldDecorator('App/ClientID', {
                    initialValue:
                      customerData && customerData[0].appId ? customerData[0].appId : '',

                    rules: [
                      {
                        message: 'Please enter your clientId',
                      },
                    ],
                  })(<Input  placeholder="ClientId" disabled />)}
                </Form.Item> */}
              </Col>
            </Row>
            <Col span={10}>
              {/* <Form.Item label="Domain/TenantId">
              {getFieldDecorator('Domain/TenantId', {
                initialValue:
                  customerData && customerData[0].tenantId ? customerData[0].tenantId : '',

                rules: [
                  {
                    message: 'Please enter your TenantId',
                  },
                ],
              })(<Input  placeholder="TenantId" disabled />)}
            </Form.Item>
            
            <Form.Item label="SecretKey/Pwd">
              {getFieldDecorator('SecretKey/Pwd', {
                initialValue: customerData && customerData[0].secret ? customerData[0].secret : '',

                rules: [
                  {
                    message: 'Please enter your SecretKey',
                  },
                ],
              })(<Input  placeholder="SecretKey" disabled />)}
            </Form.Item> */}
            </Col>
            <Form.Item>
              <Button
                loading={this.props.updating}
                style={{ float: 'right' }}
                type="primary"
                htmlType="submit"
              >
                Update
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}
const WrappedApp = Form.create()(Azure);

export default WrappedApp;
